import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import FooterCopyright from "../../components/footer/FooterCopyright";
import FooterNewsletter from "../../components/footer/FooterNewsletter";
import MobileViewFooter from "./MobileViewFooter";
import { Divider } from "antd";
import { useSelector } from "react-redux";

const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu
}) => {

  const brands = useSelector((state) => state.brands.list || []);

  // Divide the brands
  const firstHalf = brands.slice(0, 6);

  const getBrandUrl = (id) => {
    return `/shop-grid-standard?page=1&limit=15&usedType=USED&status=1&isVisible=1&brands=${id}&category=&color=&ram=&storage=`;
  };

  const renderBrandDiv = (brandList) => (
    <div style={{ margin: "2% 0% 2% 10%", alignContent: "center" }}>
      {brandList.map((brand, index) => (
        <div key={brand._id} style={{ margin: index % 2 !== 0 ? "25px 0px" : "0" }}>
          <a style={{ color: "white" }} href={getBrandUrl(brand._id)}>{brand.name}</a>
        </div>
      ))}
    </div>
  );
  return (
    <>
      <div className="why-choose-section" style={{ backgroundColor: "#1C4598", padding: 10 }}>
        <center><h4 style={{ marginTop: 10, color: "white", fontWeight: 600 }}>Why Choose 09Mobile Gallery?</h4></center>
        <center style={{ color: "white" }}>Refurbished Phones, New Possibilities - Quality You Can Trust, Prices You'll Love!</center>
        <Divider style={{ borderColor: '#FFFFFF' }} />
      </div>
      <footer style={{ backgroundColor: "#1C4598" }} className={clsx("footer-area", backgroundColorClass, spaceTopClass, spaceBottomClass, extraFooterClass, spaceLeftClass, spaceRightClass)}>
        <div className={`${containerClass ? containerClass : "container"}`}>
          <div className="row">
            <div
              className={`${sideMenu ? "col-xl-2 col-sm-4" : "col-lg-3 col-sm-4"
                }`}
            >
              {/* footer copyright */}
              <FooterCopyright
                footerLogo="/assets/img/logo/logo2.png"
                spaceBottomClass="mb-30"
              />
            </div>
            <div
              className={`${sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-4"
                }`}
            >
              <div className="footer-widget mb-30 ml-30">
                <div className="footer-title">
                  <h3 >TOP BRANDS</h3>
                </div>
                <div className="footer-list">
                  {renderBrandDiv(firstHalf)}
                </div>
              </div>
            </div>
            <div
              className={`${sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-4"
                }`}
            >
              <div
                className={`${sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
                  }`}
              >
                <div className="footer-title">
                  <h3>SELL DEVICE</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/shop-grid-standard?page=1&limit=15&status=1&isVisible=1&category=Mobile"}>Mobile</Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/shop-grid-standard?page=1&limit=15&status=1&isVisible=1&category=Watch"}>
                        Smart Watch
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/shop-grid-standard?page=1&limit=15&status=1&isVisible=1&category=Tablet"}>
                        Tablets
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/shop-grid-standard?page=1&limit=15&status=1&isVisible=1&category=Laptop"}>
                        Laptop
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/shop-grid-standard?page=1&limit=15&status=1&isVisible=1&category=Airpod"}>
                        Airpods
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/shop-grid-standard?page=1&limit=15&status=1&isVisible=1&category=Accessories"}>
                        Accessories
                      </Link>
                    </li>
                    {/*<li>
                    <Link to={process.env.PUBLIC_URL + "#/"}>Size guide</Link>
                  </li>
                   <li>
                    <Link to={process.env.PUBLIC_URL + "#/"}>FAQs</Link>
                  </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={`${sideMenu ? "col-xl-3 col-sm-4" : "col-lg-2 col-sm-6"
                }`}
            >
              <div
                className={`${sideMenu
                  ? "footer-widget mb-30 ml-145"
                  : "footer-widget mb-30 ml-75"
                  }`}
              >
                <div className="footer-title">
                  <h3>MORE INFO</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <a
                        href="/contact"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Contact Us
                      </a>
                    </li>
                    <li>
                      <a
                        href="/faq"
                        rel="noopener noreferrer"
                      >
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a
                        href="/policy"
                        rel="noopener noreferrer"
                      >
                        Return Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/@09mobilegallery"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Youtube
                      </a>
                    </li>
                    <li>
                      <a
                        href="/t&c"
                        rel="noopener noreferrer"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        href="/policy"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="/policy"
                        rel="noopener noreferrer"
                      >
                        Refund Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="/contact"
                        rel="noopener noreferrer"
                      >
                        Customer Support
                      </a>
                    </li>
                    <li>
                      <a
                        href="/orders"
                        rel="noopener noreferrer"
                      >
                        Track Order
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="/career"
                        rel="noopener noreferrer"
                      >
                        Careers
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={`${sideMenu ? "col-xl-2 col-sm-8" : "col-lg-3 col-sm-6"
                }`}
            >
              {/* footer newsletter */}
              <FooterNewsletter
                spaceBottomClass="mb-30"
                spaceLeftClass="ml-70"
                sideMenu={sideMenu}
              />
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: "#1C4598" }}>
          <Divider style={{ borderColor: '#FFFFFF' }} />
          {/* <center><h4 style={{marginTop:10, color:"white", fontWeight:600,paddingBottom:-10}}>Copyright @ 2024 09mobilegallery All rights reserved</h4></center> */}
          <center style={{ color: "white", paddingBottom: 30, zIndex: 1 }}>&copy; {new Date().getFullYear()} 09mobilegallery All rights reserved</center>
        </div>
      </footer >
      <div className="MobileView-footer">
        <MobileViewFooter />
      </div>
    </>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string
};

export default FooterOne;
